
import React, { useState, useEffect } from 'react';
import {
  Button,
  Label,
  Modal,
} from 'reactstrap';
import _ from 'lodash';
import SlaveAvInput from '../../../commons/SlaveAvInput';
import Services from '../services';
import NumberFormatter from '../../../commons/NumberFormatter';
import RFField from '../../../components/Form/RFField';
import RFForm from '../../../components/Form/RFForm';
import PriceInputComponent from '../../../components/Form/PriceInputComponent';
import { calculatePrice } from '../../../components/Form/PriceCalculator';
import moment from 'moment';
import SelectField from '../../../components/Form/SelectField';
import TimeFormatter from '../../../commons/TimeFormatter';


const ROW_STYLE = { marginBottom: '15px' };
const AjanlatCikkForm = (props) => {
  const {
    id,
    globals,
    isElkuldott,
    cikkek,
    penznem,
    setCikkek,
    toggleShowCikk,
  } = props;

  const [cikk, setCikk] = useState(null);
  const [cikkNev, setCikkNev] = useState('');
  const [newCikk, toggleNewCikk] = useState(false);
  const [mennyiseg, setMennyiseg] = useState('');
  const [afaId, setAfaId] = useState('');
  const [afaSzazalek, setAfaSzazalek] = useState('');
  const [nettoEgysegar, setNettoEgysegar] = useState('');
  const [afaEgysegar, setAfaEgysegar] = useState('');
  const [bruttoEgysegar, setBruttoEgysegar] = useState('');
  const [nettoOsszAr, setNettoOsszAr] = useState('');
  const [afaOsszAr, setAfaOsszAr] = useState('');
  const [bruttoOsszAr, setBruttoOsszAr] = useState('');
  const [cikkModal, toggleCikkModal] = useState(true);
  const [afaKulcsOptions, setAfaKulcsOptions] = useState([]);

  const { removeSpacesFromString } = NumberFormatter;

  useEffect(() => {
    getAjanlatCikkRendeles();
  }, []);

  useEffect(() => {
    toggleShowCikk(cikkModal);
  }, [cikkModal]);

  const loadCikkOptions = (input, callback) => {
    if (_.isEmpty(input)) callback([]);
    Services.listCikk({ param: input, receptura: false, ignoretipus: true, datum: TimeFormatter.formatDate(props.kelte) }, (err, res) => {
      if (!err) {
        const options = res[0].filter(k => k.megnevezes.toLowerCase().includes(input.toLowerCase()));
        callback(options);
      } else {
        callback([]);
      }
    });
  };

  const generateUUID = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
  };

  const clearPrices = () => {
    setNettoEgysegar('');
    setAfaEgysegar('');
    setBruttoEgysegar('');
    setNettoOsszAr('');
    setAfaOsszAr('');
    setBruttoOsszAr('');
  };

  const round = (value, precision) => {
    const multiplier = 10 ** (precision || 0);
    return Math.round(value * multiplier) / multiplier;
  };

  const getAjanlatCikkRendeles = () => {
    const edited = id ? cikkek.find(c => c.id === id) : null;
    if (edited) {
      toggleNewCikk(edited.new);
      setCikk(edited.cikk);
      setCikkNev(edited.cikkNev);
      setMennyiseg(edited.mennyiseg);
      setNettoEgysegar(edited.nettoEgysegAr);
      setAfaEgysegar(edited.afaAr);
      setBruttoEgysegar(edited.bruttoEgysegAr);
      setNettoOsszAr(edited.nettoErtek);
      setAfaOsszAr(edited.afaOssz);
      setBruttoOsszAr(edited.bruttoErtek);
      setAfaId(edited.afaId);
      setAfaSzazalek(edited.afaSzazalek);
    }
  };

  const handleArInput = (priceArray) => {
    let [nettoEgysegAr, nettoEgysegAfa, bruttoEgysegAr, nettoBeszAr, bruttoBeszAfa, bruttoBeszAr] = priceArray;
    setNettoEgysegar(nettoEgysegAr);
    setAfaEgysegar(nettoEgysegAfa);
    setBruttoEgysegar(bruttoEgysegAr);
    setNettoOsszAr(nettoBeszAr);
    setAfaOsszAr(bruttoBeszAfa);
    setBruttoOsszAr(bruttoBeszAr);
  }

  const handleCikkChange = (v) => {
    if (!v) {
      setMennyiseg('');
      clearPrices();
    }
    setCikk(v);
    setCikkNev(v ? v.megnevezes : '');
    setAfaId(v ? v.aktualisAfaId : '');
    setAfaSzazalek(v ? v.aktualisAfaErtek : '');
    setMennyiseg('');
    setNettoEgysegar('');
    setAfaEgysegar('');
    setBruttoEgysegar('');
    setNettoOsszAr('');
    setAfaOsszAr('');
    setBruttoOsszAr('');
  }

  const handleMennyisegChange = (e, value) => {
    setMennyiseg(value);
    let priceArray;
    if (value && value > 0) {
      priceArray = calculatePrice(nettoEgysegar, afaSzazalek, value, penznem && penznem.tizedesjegy);
      handleArInput(priceArray);
    }
  }

  const saveAjanlatCikkRendeles = () => {
    if (cikkek.find(c => !id && c.cikkId === cikk.id)) {
      globals.addWarning('A kiválaszott cikk már szerepel a felsorolásban!');
      return;
    }
    if (!bruttoEgysegar) {
      globals.addError('Ár megadása kötelező!');
      return;
    }
    if (isNaN(Number(mennyiseg))) {
      globals.addError('Nem megfelelő mennyiség formátum!');
      return;
    }
    if (!id) {
      let submitObj = {};
      submitObj.id = generateUUID();
      submitObj.new = true;
      submitObj.cikk = cikk;
      submitObj.cikkNev = cikkNev;
      submitObj.cikkId = cikk && cikk.id;
      submitObj.mennyiseg = removeSpacesFromString(mennyiseg);
      submitObj.nettoEgysegAr = removeSpacesFromString(nettoEgysegar);
      submitObj.afaAr = removeSpacesFromString(afaEgysegar);
      submitObj.bruttoEgysegAr = Number(removeSpacesFromString(bruttoEgysegar));
      submitObj.afaId = afaId && parseInt(afaId, 10);
      submitObj.afaSzazalek = afaSzazalek;
      submitObj.nettoErtek = removeSpacesFromString(nettoOsszAr);
      submitObj.afaOssz = removeSpacesFromString(afaOsszAr);
      submitObj.bruttoErtek = Number(removeSpacesFromString(bruttoOsszAr));

      cikkek.push(submitObj);
      setCikkek(cikkek);
    } else {
      let submitObj = {};
      submitObj.id = id;
      submitObj.new = newCikk;
      submitObj.cikk = cikk;
      submitObj.cikkNev = cikkNev;
      submitObj.cikkId = cikk && cikk.id;
      submitObj.mennyiseg = removeSpacesFromString(mennyiseg);
      submitObj.nettoEgysegAr = removeSpacesFromString(nettoEgysegar);
      submitObj.afaAr = removeSpacesFromString(afaEgysegar);
      submitObj.bruttoEgysegAr = Number(removeSpacesFromString(bruttoEgysegar));
      submitObj.afaId = afaId && parseInt(afaId, 10);
      submitObj.afaSzazalek = afaSzazalek;
      submitObj.nettoErtek = removeSpacesFromString(nettoOsszAr);
      submitObj.afaOssz = removeSpacesFromString(afaOsszAr);
      submitObj.bruttoErtek = Number(removeSpacesFromString(bruttoOsszAr));

      const editedIdx = cikkek.findIndex(c => c.id == id);
      let newCikkek = [...cikkek];
      newCikkek[editedIdx] = submitObj;
      setCikkek(newCikkek);
    }

    toggleCikkModal();
  };

  const renderForm = () => {
    const selectStyles = {
      control: base => ({
        ...base,
        '&:focus': { borderColor: 'red' }, // border style on hover
        border: '1px solid lightgray', // default border color
        boxShadow: 'none', // no box-shadow
        borderRadius: '0'
      }),
    };
    return (
      <React.Fragment>
        <div className="row no-gutters" style={ROW_STYLE}>
          <div className="col-md-12" style={{ paddingRight: '2px' }}>
            <SelectField
              variant='async'
              label='Cikk:'
              name="cikk"
              id="cikk"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={handleCikkChange}
              loadOptions={_.debounce(loadCikkOptions, 1000)}
              getOptionLabel={option => option.megnevezes + ' (' + option.cikkszam + ')'}
              getOptionValue={option => option.id}
              value={cikk}
              isDisabled={isElkuldott}
              isClearable
              // defaultOptions
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-7" style={ROW_STYLE}>
            <RFField
              label={'Megnevezés: '}
              name="megnevezes"
              id="megnevezes"
              value={cikkNev}
              onChange={(e, v) => setCikkNev(v)}
              disabled={isElkuldott || !cikk}
              autoComplete="off"
            />
          </div>
          <div className="col-md-5" style={ROW_STYLE}>
            <RFField
              label={'Cikkszám: '}
              name="cikkszam"
              id="cikkszam"
              value={cikk ? cikk.cikkszam : ''}
              disabled
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-7" style={ROW_STYLE}>
            <SlaveAvInput
              key="mennyiseg"
              id="mennyiseg"
              label="Mennyiség: *"
              required
              disabled={!cikk}
              value={mennyiseg}
              autoComplete="off"
              onChange={handleMennyisegChange}
              szuroTipus={NumberFormatter.OSSZEG}
              emptyStringOnZero
              inputGroupAddon={cikk ? cikk.mennyisegiEgyseg : ''}
            />
          </div>
          <div className="col-md-5" style={ROW_STYLE}>
            <RFField
              label={'ÁFA%:'}
              name="afa"
              id="afa"
              value={afaSzazalek}
              disabled
            />
          </div>
        </div>
        <PriceInputComponent
          disabledArray={[(!cikk || !mennyiseg || mennyiseg === '0')]}
          valueArray={[nettoEgysegar, afaEgysegar, bruttoEgysegar, nettoOsszAr, afaOsszAr, bruttoOsszAr]}
          onChangeArray={handleArInput}
          afa={afaSzazalek}
          mennyiseg={mennyiseg}
          tizedesjegy={penznem && penznem.tizedesjegy}
        />
      </React.Fragment>
    );
  };

  const renderButtons = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <Button
            className="btn-cursor-pointer"
            color="success"
            type="submit"
            style={{ marginRight: '10px' }}
          >
            Mentés
          </Button>
          <Button type="button" color="secondary" onClick={() => toggleCikkModal()}>
            Mégsem
          </Button>
        </div>
      </div>
    );
  };

  return (
    <Modal isOpen={cikkModal} toggle={() => toggleCikkModal(!cikkModal)} backdrop="static" size="md">
      <RFForm
        modal
        onSubmit={saveAjanlatCikkRendeles}
        title={'Cikk' + (id ? ' módosítása' : ' hozzáadása')}
        footer={renderButtons()}
      >
        <div className="row">
          <div className="col-md-12">
            {renderForm()}
          </div>
        </div>
      </RFForm>
    </Modal>
  );
};

export default AjanlatCikkForm;
